// 上面 一块的区域
import React, { useState, useEffect } from "react";
import { isMobile } from "@/utils/common";

import { CheckOutlined } from "@ant-design/icons";
import { Droppable, Draggable } from "react-beautiful-dnd";
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#a8d1f7" : "#cbe4fb",
  // padding: 10,
  border: "1px solid #fff",
  display: "flex",
  minHeight: 177,
  flexWrap: "wrap",
});

export default function DroppableComUp({
  item1,
  direction,
  selctListObj,
  update,
}) {
  const [draggingIndex, setDraggingIndex] = useState();

  useEffect(() => {
    update && update(Math.random());
  }, [draggingIndex]);

  if (!item1.id) {
    return null;
  }
  const getItemStyle = (
    isDragging,
    draggableStyle,
    draggableleId,
    hasTitle,
    onlyPicture,
    emptyLine = 0
  ) => {
    let styles = { transform: null, transition: null };
    if (draggableleId == sessionStorage.getItem("draggableId")) {
      styles = draggableStyle;
    }
    const h = onlyPicture ? 120 : 146 + emptyLine * 24;
    return {
      ...draggableStyle,
      ...styles,
      userSelect: "none",
      margin: 10,
      overflow: "hidden",

      textAlign: isDragging && isMobile ? "center" : "left",
      border: isDragging ? "1px solid red" : "1px solid",
      background: isDragging ? "rgb(222, 235, 255)" : "#f5f5f5",
      width: isDragging && isMobile ? 40 : 120,
      height:
        isDragging && isMobile ? 40 : 120,
      minHeight: isDragging && isMobile ? 40 : 120,
    };
  };

  let _childs = [];
  if (direction) {
    _childs = item1.options;
  } else {
    _childs = item1.childs;
  }

  return (
    <Droppable droppableId={item1.id + ""} direction="horizontal">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}
          onTouchCancel={() => {
            setDraggingIndex(undefined);
          }}
          onTouchEnd={() => {
            setDraggingIndex(undefined);
          }}
        >
          {(_childs || []).map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.codeValue + ""}
              index={index}
            >
              {(provided, snapshot) => {
                const patnTitle = />.+</;
                const hasTitle = patnTitle.test(item.description);
                const patnPic = /^(<p>)?<div class="media-wrap.*(<\/p>)?/;
                const onlyPicture = patnPic.test(item.description);
                const emptyLine = item.description.match(/<p><\/p>/g) || [];
                let html = item.description;
                html = html.replace(/<p><\/p>/g, "<br />");
                html = html.replace(/\n\n/g, "<br />");
                html = html.replace(/\s{2}/g, "&nbsp;&nbsp;");
                html = html.replace(/height="[0-9]+px"/g, 'height="100%"');
                html = html.replace(/height:.?[0-9]+px/g, "height:100%");
                html = html.replace(/width="[0-9]+px"/g, 'width="100%"');
                html = html.replace(/width:.?[0-9]+px/g, "width:100%");
                return (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    onTouchStart={() => {
                      setDraggingIndex(index);
                    }}
                    style={{
                      ...getItemStyle(
                        snapshot.isDragging || draggingIndex === index,
                        provided.draggableProps.style,
                        item.codeValue,
                        hasTitle,
                        onlyPicture,
                        emptyLine.length
                      ),
                    }}
                  >
                    {selctListObj.includes(item.codeValue + "") && (
                      <CheckOutlined
                        style={{
                          color: "#72b5e9",
                          float: "right",
                          marginRight: 4,
                          marginTop: 4,
                        }}
                      />
                    )}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: html,
                      }}
                    ></div>
                  </div>
                );
              }}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}
